import React, { SyntheticEvent, useState } from 'react';
import { Button, Checkbox, FormField, Header, Icon, Modal, ModalActions, ModalContent, Popup } from 'semantic-ui-react';

interface DeleteUserModalProps {
    id: string;
    submit: (event: SyntheticEvent, userId: string | undefined) => void;
}

const DeleteUserModal = (props: DeleteUserModalProps) => {

    const [openModal, setOpenModal] = useState(false);
    const [confirm, setConfirm] = useState(false);

    const handleOpen = (event: SyntheticEvent, prospectId: string) => {
        event.preventDefault();
        setOpenModal(true);
    };

    const handleCancel = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(false);
    };

    return (
        <Modal
            closeOnDimmerClick
            closeIcon={true}
            size="small"
            onClose={(event) => handleCancel(event)}
            open={openModal}
            trigger={
                <Popup
                    trigger={
                        <Button color="red" icon size="mini" onClick={(event) => handleOpen(event, props.id)}>
                            <Icon name="power off" />
                        </Button>
                    }
                    content='Desactivar usuario'
                    position='top center'
                    size='small'
                    inverted
                />
            } >
            <Header icon="power off" content="Desactivar usuario" />
            <ModalContent>
                <p> ¿Estas seguro de deseas desactivar a este usuario?. Esta accion no se puede deshacer.</p>

                <div className="ui form">
                    <FormField>
                        <Checkbox
                            label="Confirmo que quiero desactivar al usuario."
                            checked={confirm}
                            onChange={(event, data) => setConfirm(confirm ? false : true)}
                        />
                    </FormField>
                </div>
            </ModalContent>
            <ModalActions>
                <Button onClick={(event) => handleCancel(event)}>
                    <Icon name="cancel" /> Cancelar
                </Button>
                <Button color="red" onClick={(event) => props.submit(event, props.id)} disabled={!confirm}>
                    <Icon name="checkmark" /> Desactivar usuario
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default DeleteUserModal;
